<template>
  <div v-rect-loading="loading" class="edit-agency-container">
    <div class="header-container">
      {{ $t(`${i18nPrefix}.${ isEditMode ? 'agencyEdit' : 'agencyAdd'}`) }}
    </div>
    <div class="agency-info">
      <div class="body-container">
        <WrappedForm
          ref="agencyInfoFormRef"
          labelWidth="150px"
          :model="agency"
          :formLines="formLines"
        >
        </WrappedForm>
      </div>
      <div class="btn-container">
        <el-button @click="handelCancel">{{ $t(`${i18nPrefix}.btn.cancel`) }}</el-button>
        <el-button type="primary" @click="handelSave">{{ $t(`${i18nPrefix}.btn.confirm`) }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { emailRegexp } from '@/utils/validator'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedForm
  },
  data () {
    return {
      i18nPrefix: 'admin.company.agency',
      loading: false,
      agency: {
        email: null,
        notes: null,
        name: null
      }
    }
  },
  computed: {
    formLines () {
      const lines = {
        notes: {
          label: this.$t(`${this.i18nPrefix}.label.notes`)
        },
        name: {
          label: this.$t(`${this.i18nPrefix}.label.name`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        },
        email: {
          disabled: this.isEditMode,
          label: this.$t(`${this.i18nPrefix}.label.email`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }, { validator: this.validateEmail, trigger: 'blur' }]
        }
      }
      return lines
    },
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    agencyId () {
      return this.$route.params.agencyId
    }
  },
  created () {
    if (this.isEditMode && this.agencyId) {
      this.initData()
    }
  },
  methods: {
    ...mapActions('agency', ['getAgencyInfoById', 'createAgency', 'updateAgency']),
    async initData () {
      this.loading = true
      try {
        const resp = await this.getAgencyInfoById(this.agencyId)
        if (resp) {
          this.agency = resp
        }
      } finally {
        this.loading = false
      }
    },
    validateEmail (rule, value, callback) {
      if (this.isEditMode) {
        callback()
      }
      let errorMsg = null
      if (!value || (value && !emailRegexp.test(value))) {
        errorMsg = this.$t('common.message.invalidEmail')
      }
      if (errorMsg) {
        callback(new Error(errorMsg))
      } else {
        callback()
      }
    },
    async handelSave () {
      const isValidate = await this.$refs.agencyInfoFormRef.submit()
      if (!isValidate) {
        return
      }
      const submitInfo = this.isEditMode ? this.updateAgency : this.createAgency
      const params = {
        ...this.agency
      }
      if (this.isEditMode) {
        params.agency_id = this.agencyId
      }
      this.loading = true
      try {
        await submitInfo(params)
        this.handelCancel()
      } finally {
        this.loading = false
      }
    },
    handelCancel () {
      this.$router.go(-1)
    }
  }
}

</script>

<style lang='scss' scoped>
.edit-agency-container {
  .header-container {
    font-size: 18px;
    font-weight: 500;
    color: #303133;
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 12px;
  }

  .agency-info {
    width: 606px;
    margin: 30px auto 0;
    .body-container {
      margin-top: 20px;

      .item-container {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .label {
          width: 15%;
          text-align: right;
          margin-right: 30px;
          display: inline-block;
        }

        .content {
          flex: 1;
          display: inline-block;

          ::v-deep {
            .el-input__inner {

              height: 32px;
              line-height: 32px;
              border-radius: 0;
            }
            .el-input__icon {
              line-height: 32px;
            }
          }
        }
      }
    }

    .btn-container {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
    }
  }

}
</style>
